import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  overviewLoader: false,
  portfolioLoading: false,
  portfoliosLoading: false,
  error: "",
  portfolio: {},
  portfolios: [],
  portfolioPagination: {},
});

export default function portfolioReducer(state = initialState, action) {
  switch (action.type) {
    // GET PORTFOLIO
    case ACTIONS.PORTFOLIO.PENDING: {
      return state.set("error", "").set("portfoliosLoading", true);
    }
    case ACTIONS.PORTFOLIO.SUCCESS: {
      return state
        .set("error", "")
        .set("portfolios", action.data.data)
        .set("portfolioPagination", action.data.pagination)
        .set("portfoliosLoading", false);
    }
    case ACTIONS.PORTFOLIO.ERROR: {
      return state.set("error", action.error).set("portfoliosLoading", false);
    }

    // Sort portfolio
    case ACTIONS.SORT_PORTFOLIOS.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_PORTFOLIOS.SUCCESS: {
      return state
        .set("error", "")
        .set("portfolios", action.data.data)
        .set("portfolioPagination", action.data.pagination);
    }
    case ACTIONS.SORT_PORTFOLIOS.ERROR: {
      return state.set("error", action.error);
    }

    // Delete portfolio
    case ACTIONS.DELETE_PORTFOLIOS.PENDING: {
      return state.set("error", "").set("portfolioLoading", true);
    }
    case ACTIONS.DELETE_PORTFOLIOS.SUCCESS: {
      return state
        .set("portfolioLoading", false)
        .set("error", "")
        .set("portfolios", action.data.data)
        .set("portfolioPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_PORTFOLIOS.ERROR: {
      return state.set("portfolioLoading", false).set("error", action.error);
    }

    // Create portfolio
    case ACTIONS.CREATE_PORTFOLIO.PENDING: {
      return state.set("portfolioLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_PORTFOLIO.SUCCESS: {
      return state
        .set("portfolioLoading", false)
        .set("error", "")
        .set("portfolios", action.data.data)
        .set("portfolioPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_PORTFOLIO.ERROR: {
      return state.set("error", action.error).set("portfolioLoading", false);
    }

    // Update portfolio
    case ACTIONS.UPDATE_PORTFOLIO.PENDING: {
      return state.set("error", "").set("portfolioLoading", true);
    }
    case ACTIONS.UPDATE_PORTFOLIO.SUCCESS: {
      if (action.data.type === "overview") {
        return state
          .set("error", "")
          .set("portfolioLoading", false)
          .set("portfolio", action.data.data);
      } else {
        return state
          .set("error", "")
          .set("portfolioLoading", false)
          .set("portfolios", action.data.data)
          .set("portfolioPagination", action.data.pagination);
      }
    }
    case ACTIONS.UPDATE_PORTFOLIO.ERROR: {
      return state.set("error", action.error).set("portfolioLoading", false);
    }

    // Get portfolio details
    case ACTIONS.GET_PORTFOLIO_DETAILS.PENDING: {
      return state
        .set("error", "")
        .set("portfolioLoading", true)
        .set("overviewLoader", true);
    }
    case ACTIONS.GET_PORTFOLIO_DETAILS.SUCCESS: {
      return state
        .set("error", "")
        .set("portfolioLoading", false)
        .set("overviewLoader", false)
        .set("portfolio", action.data);
    }
    case ACTIONS.GET_PORTFOLIO_DETAILS.ERROR: {
      return state
        .set("error", action.error)
        .set("overviewLoader", false)
        .set("portfolioLoading", false);
    }

    // GET PORTFOLIO BUDGET SUMMARY
    case ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY.PENDING: {
      return state.set("error", "").set("portfolioBudgetSummaryLoading", true);
    }
    case ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY.SUCCESS: {
      return state
        .set("portfolioBudgetSummaryLoading", false)
        .set("error", "")
        .set("portfolioBudgetSummary", action.data);
    }
    case ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY.ERROR: {
      return state
        .set("portfolioBudgetSummaryLoading", false)
        .set("error", action.error);
    }
    // GET PORTFOLIO PROGRESS SUMMARY
    case ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY.PENDING: {
      return state.set("error", "").set("portfolioProgressSummaryLoading", true);
    }
    case ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY.SUCCESS: {
      return state
        .set("portfolioProgressSummaryLoading", false)
        .set("error", "")
        .set("portfolioProgressSummary", action.data);
    }
    case ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY.ERROR: {
      return state
        .set("portfolioProgressSummaryLoading", false)
        .set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
